/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CertRosetteAltIcon20Light = forwardRef('CertRosetteAltIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 1a6 6 0 0 0-4 10.472v6.534a1 1 0 0 0 1.596.802L10 17.023l2.404 1.785A1 1 0 0 0 14 18.006v-6.534A6 6 0 0 0 10 1ZM5 7a5 5 0 1 1 10 0A5 5 0 0 1 5 7Zm8 5.197A5.972 5.972 0 0 1 10 13a5.973 5.973 0 0 1-3-.803v5.809l2.404-1.786a1 1 0 0 1 1.192 0L13 18.006v-5.809Z" })));
});
